import {
    useMutation,
    useQuery,
} from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { Delete, Get, Post, Put } from "../api";
import API_CONSTANTS from "../constants/api";
import { prepareData } from "../helpers/apiHelper";
import { appendQueryParams } from "../helpers/queryHelper";;

export const useEmailLogs = (params) => {
    const token = useSelector((state) => state.user?.token)
    return useQuery({
        queryKey: ["email-logs", params],
        queryFn: async () => {
            const { data } = await Get({
                path: `${API_CONSTANTS.EMAIL_LOGS.base}?${appendQueryParams({params})}`,
                token,
                toastError: true,
            })
            return data
        },
        keepPreviousData: true
    })
}

export const useEmailLogsFacet = () => {
    const token = useSelector((state) => state.user?.token)
    return useQuery({
        queryKey: ["email-logs-facet"],
        queryFn: async () => {
            const { data } = await Get({
                path: API_CONSTANTS.EMAIL_LOGS.getFacet,
                token,
                toastError: true,
            })
            return data
        },
    })
}

export const useCreateEmailLog = () => {
    const token = useSelector((state) => state.user?.token)
    return useMutation({
        mutationFn: async (body) => {
            body = prepareData(body, API_CONSTANTS.EMAIL_LOGS.dataKeys)
            const { data } = await Post({
                path: API_CONSTANTS.EMAIL_LOGS.base,
                token,
                body
            })
            return data
        },
    })
}

export const useUpdateEmailLog = (id) => {
    const token = useSelector((state) => state.user?.token)
    return useMutation({
        mutationFn: async (body) => {
            body = prepareData(body, API_CONSTANTS.EMAIL_LOGS.dataKeys)
            const { data } = await Put({
                path: `${API_CONSTANTS.EMAIL_LOGS.base}/${id}`,
                token,
                body
            })
            return data
        },
    })
}

export const useDeleteEmailLog = () => {
    const token = useSelector((state) => state.user?.token)
    return useMutation({
        mutationFn: async (id) => {
            const { data } = await Delete({
                path: `${API_CONSTANTS.EMAIL_LOGS.base}/${id}`,
                token,
            })
            return data
        },
    })
}